import { Alert, Box, Stack, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useHistory } from "react-router-dom";

import { IconButton } from "../../components/IconButton";
import { PageWrapper } from "../../components/PageWrapper";
import { PageContent } from "./PageContent";

interface ShiftDetailsErrorPageProps {
  message?: string;
}

export function ShiftDetailsErrorPage(props: ShiftDetailsErrorPageProps) {
  const { message = "There was an error loading the shift details. Please try again." } = props;

  const history = useHistory();

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <Stack sx={{ paddingTop: 5, paddingX: 6 }}>
          <IconButton
            iconType="chevron-left"
            variant="outlined"
            onClick={() => {
              history.goBack();
            }}
          />
        </Stack>
        <PageContent>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Alert severity="error">{message}</Alert>
          </Box>
        </PageContent>
      </PageWrapper>
    </ThemeProvider>
  );
}
